export enum enumRespErrors {
  AccessNotAllowed = 'access_not_allowed',
  AccountTemporarilyLocked = 'account_temporarily_locked',
  AccountBlocked = 'account_blocked',
  AdditionalQuotePaymentIsAlreadyPayed = 'additional_quote_payment_is_already_payed',
  AdminContactNotFound = 'admin_contact_not_found',
  BetaFeatureDisabled = 'beta_feature_disabled',
  BondAlreadySent = 'already_sent',
  BondAlreadySet = 'already_set',
  BondAlreadyPaid = 'bill_is_already_paid',
  BlAreRequired = 'bl_are_required',
  AutoGeneratedContainerSpecification = 'auto_generated_container_specification',
  BillIsAlreadyPaid = 'bill_is_already_paid',
  BillIsOutdated = 'bill_is_outdated',
  BillIsNotPaidOrRefunded = 'bill_is_not_paid_or_refunded',
  BondNotFoundOrWrongState = 'bond_not_found_or_wrong_state',
  BondRequestWrongState = 'bond_request_wrong_state',
  QuoteIsAlreadyAtVoyage = 'quote_is_already_at_voyage',
  CannotChangeIsOptionalFlag = 'cannot_change_isoptional_flag',
  CannotDetachDefaultContact = 'cannot_detach_default_contact',
  CannotRemoveDefaultEntity = 'cannot_remove_default_entity',
  CannotValidateEmail = 'cannot_validate_email',
  CatalogItemCodeWithdrawn = 'catalog_item_code_withdrawn',
  RecaptchaTokenInvalid = 'captcha_token_invalid',
  CompanyHasMissingFields = 'company_has_missing_fields',
  // #13536: no knownErrors entry on purpose — ErrorResponseInterceptor opens CompanyProfileIncompleteModal for it
  CompanyProfileIncomplete = 'company_profile_incomplete',
  ContactAlreadyAttached = 'contact_already_attached',
  ContainerCutoffValidationFailed = 'container_cutoff_validation_failed',
  ContainerHasDifferentVoyage = 'container_has_different_voyage',
  ContainerNotFound = 'container_not_found',
  ContainerSpecificationNotFound = 'container_specification_not_found',
  ControllingPersonDuplicated = 'controlling_person_duplicated',
  ControllingPersonsIncomplete = 'controlling_persons_incomplete',
  CouponNotUnique = 'coupon_is_not_unique',
  DatabaseNotSet = 'database_not_set',
  DefaultContactIsNotAttached = 'default_contact_is_not_attached',
  DependenciesConflict = 'dependencies_conflict',
  DiscountCannotBeApplied = 'discount_cannot_be_applied',
  DiscountIsNotActive = 'discount_is_not_active',
  DiscountNotFound = 'discount_not_found',
  DiscountUnauthorized = 'discount_unauthorized',
  DocumentsCutoffValidationFailed = 'documents_cutoff_validation_failed',
  DuplicateUserName = 'duplicate_user_name',
  EffectiveDateInPast = 'effective_date_in_past',
  EmailConfirmationFailed = 'email_confirmation_failed',
  EmailNotConfirmed = 'email_not_confirmed',
  EmailNotExists = 'email_not_exists',
  EntityIsNotFound = 'entity_is_not_found',
  EntityNotFromUs = 'entity_not_from_us',
  EntityIsLocked = 'entity_is_locked',
  EntityNotValid = 'entity_not_valid',
  EntrySummaryAlreadyHasStatement = 'entry_summary_already_has_statement',
  EntrySummaryAlreadySent = 'entry_summary_already_sent',
  EventAlreadySyncronized = 'event_already_syncronized',
  FailedToChangePassword = 'failed_to_change_password',
  FileIsNotReady = 'file_is_not_ready',
  HtsChatAlreadyLinked = 'hts_chat_already_linked',
  HtsChatAnswerRequired = 'hts_chat_answer_required',
  HtsChatAnswerTooLong = 'hts_chat_answer_too_long',
  HtsChatClassifierRejectedRequest = 'hts_chat_classifier_rejected_request',
  HtsChatClassifierTimeout = 'hts_chat_classifier_timeout',
  HtsChatClassifierUnauthorized = 'hts_chat_classifier_unauthorized',
  HtsChatClassifierUnavailable = 'hts_chat_classifier_unavailable',
  HtsChatClassifierUnreadable = 'hts_chat_classifier_unreadable',
  HtsChatCompleted = 'hts_chat_completed',
  HtsChatConversationRequired = 'hts_chat_conversation_required',
  HtsChatDescriptionTooLong = 'hts_chat_description_too_long',
  HtsChatEnded = 'hts_chat_ended',
  HtsChatEntrySummaryOnly = 'hts_chat_entry_summary_only',
  HtsChatLinkConflict = 'hts_chat_link_conflict',
  HtsChatMessageRequired = 'hts_chat_message_required',
  HtsChatMessageTooLong = 'hts_chat_message_too_long',
  HtsChatMessagesRequired = 'hts_chat_messages_required',
  HtsChatNoAnswer = 'hts_chat_no_answer',
  HtsChatNotFinished = 'hts_chat_not_finished',
  HtsChatNotFound = 'hts_chat_not_found',
  HtsChatResultExpiredCode = 'hts_chat_result_expired_code',
  HtsChatResultUnknownCode = 'hts_chat_result_unknown_code',
  HtsChatTooManyMessages = 'hts_chat_too_many_messages',
  HtsChatTooManyRequests = 'hts_chat_too_many_requests',
  HtsChatTurnInProgress = 'hts_chat_turn_in_progress',
  HtsSuggestionCodeWithdrawn = 'hts_suggestion_code_withdrawn',
  HtsSuggestionNotFound = 'hts_suggestion_not_found',
  HtsSuggestionNotSimilar = 'hts_suggestion_not_similar',
  HtsSuggestionReferenceRequired = 'hts_suggestion_reference_required',
  HtsSuggestionTextTooLong = 'hts_suggestion_text_too_long',
  ImporterRegistrationStartFailed = 'importer_registration_start_failed',
  ImporterAndConsigneeAreForeign = 'importer_and_consignee_are_foreign',
  InvalidBill = 'invalid_bill',
  InvalidCredentials = 'invalid_credentials',
  InvalidEntrySummary = 'invalid_entry_summary',
  InvitationOverdue = 'invitation_overdue',
  InvitationAlreadyAccepted = 'invitation_already_accepted',
  InviteAlreadyActivated = 'invite_already_activated',
  InviteAlreadyBlocked = 'invite_already_blocked',
  InvalidIsf = 'invalid_isf',
  InvalidQuery = 'invalid_query',
  InvalidState = 'invalid_state',
  InvalidUsernameOrPassword = 'invalid_username_or_password',
  InvoiceAlreadyExists = 'invoice_already_exists',
  IsfUnrecoverable = 'isf_unrecoverable',
  ItemNotPaid = 'item_not_paid',
  LdsResponseContainedAnError = 'lds_response_contained_an_error',
  LineDescriptionRequired = 'line_description_required',
  MasterAndHouseBlsAreRequired = 'master_and_house_bls_are_required',
  MasterBlAreRequired = 'master_bl_are_required',
  MissingRequiredDocuments = 'missing_required_documents',
  NotPaid = 'not_paid',
  NotSent = 'not_sent',
  NotUpToDate = 'not_up_to_date',
  NotValid = 'not_valid',
  OrganizationFilingRestricted = 'organization_filing_restricted',
  PartnershipTypeMissing = 'partnership_type_missing',
  PaymentFailed = 'payment_failed',
  PaymentNotReady = 'payment_not_ready',
  PaymentTypeAlreadyEqualToNewValue = 'payment_type_already_equal_to_new_value',
  PaymentTypeCannotBeChanged = 'payment_type_cannot_be_changed',
  PaymentTypeCannotBeChangedToAch = 'payment_type_cannot_be_changed_to_ach',
  ProductDetailsDoesNotExist = 'product_details_does_not_exist',
  RequestNotValid = 'request_not_valid',
  RouteIsNotPublished = 'route_is_not_published',
  SpecificationAlreadyExists = 'specification_already_exists',
  SpecifiedSubcostsAreNotOptional = 'specified_subcosts_are_not_optional',
  StartDateInPast = 'start_date_in_past',
  StatementIsNotFoundOnLds = 'statement_is_not_found_on_lds',
  StatementIsSharedBetweenUsers = 'statement_is_shared_between_users',
  UserCannotBeDeleted = 'user_cannot_be_deleted',
  UserExists = 'user_exists',
  VoyageIsNotFound = 'voyage_is_not_found',
  VoyageIsNotPublished = 'voyage_is_not_published',
  WarehouseCutoffValidationFailed = 'warehouse_cutoff_validation_failed',
  WrongBillState = 'wrong_bill_state',
  WrongBondTypeToChangeState = 'wrong_bond_type_to_change_state',
  WrongEntityState = 'wrong_entity_state',
  WrongEntrySummaryState = 'wrong_entry_summary_state',
  WrongPricingType = 'wrong_pricing_type',
  WrongState = 'wrong_state',
  WrongVoyagePublishingState = 'wrong_voyage_publishing_state',
}
